import { cn } from "@/lib/cn";

export function CropMarks({ className }: { className?: string }) {
  const markClass = "absolute w-6 h-6 border-[var(--color-fg-tertiary)]";

  return (
    <div className={cn("pointer-events-none absolute inset-0", className)}>
      <div className={cn(markClass, "top-4 left-4 border-t border-l")} />
      <div className={cn(markClass, "top-4 right-4 border-t border-r")} />
      <div className={cn(markClass, "bottom-4 left-4 border-b border-l")} />
      <div className={cn(markClass, "bottom-4 right-4 border-b border-r")} />
    </div>
  );
}
